var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencilIcon = function SvgPencilIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C5158",
    d: "m17.76 5.732-3.492-3.49a1.25 1.25 0 0 0-1.768 0l-9.634 9.633a1.24 1.24 0 0 0-.366.884v3.491a1.25 1.25 0 0 0 1.25 1.25h13.125a.624.624 0 1 0 0-1.25H9.009l8.75-8.75a1.25 1.25 0 0 0 0-1.768M7.24 16.25H3.75V12.76l6.875-6.875 3.491 3.491zM15 8.492 11.51 5l1.874-1.875 3.491 3.492z"
  })));
};
export default SvgPencilIcon;